import { businessData } from "./business";

export type CatalogProduct = {
  name: string;
  slug: string;
  categoryId: string;
  categoryTitle: string;
  description: string;
  image: string;
  sku: string;
  moq: number;
  usp?: string;
  tags?: string[];
  keywords?: string;
  meta?: {
    seoTitle?: string;
    seoDescription?: string;
    ogImage?: string;
  };
  botanicalName?: string;
  extractionMethod?: string;
  activeCompounds?: string;
  relatedProducts?: CatalogProductSummary[];
};

export type CatalogProductSummary = Pick<CatalogProduct, "name" | "slug" | "image" | "sku">;

export const productSlug = (name: string) =>
  name
    .toLowerCase()
    .replace(/%/g, "-percent-")
    .replace(/\+/g, "-plus-")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

export const productCatalog: CatalogProduct[] = businessData.categories.flatMap((category) =>
  (businessData.categoryProducts[category.id as keyof typeof businessData.categoryProducts] || []).map(
    (name, index) => ({
      name,
      slug: productSlug(name),
      categoryId: category.id,
      categoryTitle: category.title,
      description: `${name} is available for private-label development within our ${category.title.toLowerCase()} manufacturing suite. Texture, fragrance, active concentration, pack format, and claim language are finalized against your approved brief and stability requirements.`,
      image: category.image,
      sku: `SB-${category.id.replace(/[^a-z]/g, "").slice(0, 4).toUpperCase()}-${String(index + 1).padStart(2, "0")}`,
      moq: 500,
    }),
  ),
);

export const getCatalogProduct = (slug: string) =>
  productCatalog.find((product) => product.slug === slug);

export const getCatalogProductsByCategory = (categoryId: string) =>
  productCatalog.filter((product) => product.categoryId === categoryId);
